/**
 * Lettermint credentials form — the two prefix checks the form runs inline,
 * pulled out so they're independently testable. Pasting one token where the
 * other belongs is the single likeliest mistake on this form: Lettermint's
 * project token starts `lm_`, its team token `lm_team_`, and the two carry
 * entirely different powers — the project token sends mail, the team token
 * manages the account (routes, webhook registrations) and never sends.
 */

/** True once the trimmed value is non-empty and either doesn't start with
 *  `lm_` at all, or is actually a team token (`lm_team_…`) pasted into this
 *  field. */
export function projectTokenPrefixError(value: string): boolean {
	const v = value.trim();
	return v.length > 0 && (!v.startsWith("lm_") || v.startsWith("lm_team_"));
}

/** True once the trimmed value is non-empty and doesn't start with
 *  `lm_team_`. */
export function teamTokenPrefixError(value: string): boolean {
	const v = value.trim();
	return v.length > 0 && !v.startsWith("lm_team_");
}
